import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

export interface ErrorState {
	code: string;
	message: string;
	details?: string;
	timestamp?: Date;
}

/**
 * Estado del último error fatal de la app (el que aterriza en /error).
 * La página de error lo consume para mostrar código/causa reales en vez
 * de un genérico. Patrón replicado de agu_infoagua__admin.
 */
@Injectable({
	providedIn: "root",
})
export class ErrorStateService {
	private readonly errorSubject = new BehaviorSubject<ErrorState | null>(null);
	public error$: Observable<ErrorState | null> =
		this.errorSubject.asObservable();

	setError(error: ErrorState): void {
		error.timestamp = new Date();
		this.errorSubject.next(error);
	}

	clearError(): void {
		this.errorSubject.next(null);
	}

	getError(): ErrorState | null {
		return this.errorSubject.value;
	}
}
